"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseUrl = void 0;
var lodash_1 = __importDefault(require("lodash"));
var query_string_1 = __importDefault(require("query-string"));
var ParseUrl = /** @class */ (function () {
    function ParseUrl() {
    }
    ParseUrl.parseLocation = function (location, key) {
        var query = query_string_1.default.parse(location.search);
        var value = lodash_1.default.get(query, key);
        if (!value || Array.isArray(value))
            throw new Error('Missing ');
        return value;
    };
    return ParseUrl;
}());
exports.ParseUrl = ParseUrl;
